import { Questionnaire } from "@/models/questionnaire";
import { defineStore } from "pinia";
import { getQuestionnaires, getReceivedQuestionnaires } from "@/services/questionnairesService";
import ReceivedQuestionnaires from "@/models/receivedQuestionnaires";

export interface IQuestionnaires {
  selectedQuestionnaire: Questionnaire;
  latestSentQuestionnaire: Questionnaire;
  sentQuestionnaires: Questionnaire[];
  receivedQuestionnaires: ReceivedQuestionnaires;
}

export const useQuestionnairesStore = defineStore("questionnaires", {
  state: (): IQuestionnaires => ({
    selectedQuestionnaire: new Questionnaire(),
    latestSentQuestionnaire: new Questionnaire(),
    sentQuestionnaires: [],
    receivedQuestionnaires: new ReceivedQuestionnaires(),
  }),

  actions: {
    async getLatestQuestionnaire(): Promise<void> {
      this.sentQuestionnaires = await getQuestionnaires();
      if (this.sentQuestionnaires.length > 1) {
        this.sentQuestionnaires.sort((a: Questionnaire, b: Questionnaire) => {
          return Date.parse(b.createdAt) - Date.parse(a.createdAt);
        });
      }
      this.latestSentQuestionnaire = this.sentQuestionnaires[0];
    },

    async getSentAndReceivedQuestionnaires(): Promise<void> {
      [this.sentQuestionnaires, this.receivedQuestionnaires] = await Promise.all([
        getQuestionnaires(),
        getReceivedQuestionnaires(),
      ]);
    },

    getCreatedAtDateString(): string {
      if (!this.selectedQuestionnaire.createdAt) {
        return "";
      } else {
        let createdAtDate = new Date(this.selectedQuestionnaire.createdAt);
        return `${createdAtDate.getDate().toString().padStart(2, "0")}/${(
          createdAtDate.getMonth() + 1
        )
          .toString()
          .padStart(2, "0")}/${createdAtDate.getFullYear()}`;
      }
    },

    getLastEditedString(lastEdited: any): string {
      if (!lastEdited) {
        return "";
      } else {
        let lastEditedDate = new Date(lastEdited);
        return `${lastEditedDate.getDate().toString().padStart(2, "0")}/${(
          lastEditedDate.getMonth() + 1
        )
          .toString()
          .padStart(2, "0")}/${lastEditedDate.getFullYear()}`;
      }
    }
  },
});
